import React, {Component, Fragment} from 'react';
import {translate} from 'react-i18next';
import * as moment from 'moment';
import 'moment/locale/de';
import config from '../../config/config.js';
import axios from 'axios';
import fileDownload from 'js-file-download';
import history from '../../history';
import QRCode from 'qrcode.react';

import PageHeader from "../elements/PageHeader";
import CodeReader from "../elements/CodeReader";
import CashRegisterApi from "../../apis/CashRegisterApi";
import swal from "sweetalert";

class CashRegisterScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newCashRegisterName: '',
            existingCashRegister: false,
            addingAccounting: false,
            availableAccountingTypes: ['INGOING', 'OUTGOING', 'OTHER', 'KASSE_LAERZ'],
            addAccountingErrors: [],
            addAccountingAmount: '',
            addAccountingComment: '',
            addAccountingType: 'INGOING',
            ticketEanManually: '',
            gotAllFoodStamps: true,
            gotCarSticker: false,
            gotElectroBeer: false,
            gotPresent: false,
            printShiftInfos: false,
            items: null,
            fiskalyClients: [],
            fiskalyClient: '',
            stewardNumber: '',
            checkOutLoading: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleNewCashRegister = this.handleNewCashRegister.bind(this);
        this.handleJoinCashRegister = this.handleJoinCashRegister.bind(this);
        this.handleCheckInTicket = this.handleCheckInTicket.bind(this);
        this.handleCheckOutSupporter = this.handleCheckOutSupporter.bind(this);
        this.handleLeaveCashRegister = this.handleLeaveCashRegister.bind(this);
        this.handleCloseCashRegister = this.handleCloseCashRegister.bind(this);
        this.handleStartAddingAccounting = this.handleStartAddingAccounting.bind(this);
        this.handleCancelAddAccounting = this.handleCancelAddAccounting.bind(this);
        this.handleAddAccounting = this.handleAddAccounting.bind(this);
        this.handleRenderPdf = this.handleRenderPdf.bind(this);
        this.handleManuallyTicket = this.handleManuallyTicket.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleRenderOverviewPdf = this.handleRenderOverviewPdf.bind(this);
        this.handlePrintAllCashRegisters = this.handlePrintAllCashRegisters.bind(this);
        this.handlePrintExcel = this.handlePrintExcel.bind(this);
        this.handleQrCodeScan = this.handleQrCodeScan.bind(this);
        this.handleItemChange = this.handleItemChange.bind(this);
    }

    componentDidMount() {
        this.props.getTicket(this.props.match.params.ean);
        this.props.getOpenCashRegisters();
        this.props.getClosedCashRegisters();
        if(this.props.cashRegister.cashRegister) {
            this.props.getCashRegister(this.props.cashRegister.cashRegister.id);
        }
        CashRegisterApi.getFiskalyClients().then(response => {
            if (response.status === 200) {
                this.setState({fiskalyClients: response.data});
            }
        })
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleNewCashRegister() {
        this.props.openCashRegister(this.state.newCashRegisterName, this.state.fiskalyClient);
        this.setState({
            newCashRegisterName: '',
            fiskalyClient: ''
        });
    }

    handleJoinCashRegister() {
        this.props.getCashRegister(parseInt(this.state.existingCashRegister ? this.state.existingCashRegister : this.props.cashRegister.openCashRegisters[0].id));
    }

    handleCheckInTicket() {
        this.props.checkInTicket(this.props.cashRegister.ticket.supporter.id, this.props.cashRegister.cashRegister.id, this.props.cashRegister.ticket.ticket.ean, this.state.gotAllFoodStamps, this.state.gotCarSticker, this.state.gotElectroBeer, this.props.project.selectedProject.ticketPrice, this.state.printShiftInfos, this.props.printer.selectedPrinter ? this.props.printer.selectedPrinter.identifier : null, this.state.items, this.state.stewardNumber);
    }

    handleCheckOutSupporter() {
        this.setState({checkOutLoading: true})
        this.props.checkOutSupporter(this.props.cashRegister.ticket.supporter.id, this.props.cashRegister.cashRegister.id, this.props.cashRegister.ticket.ticket.ean, this.state.gotPresent, this.props.project.selectedProject.ticketPrice);
    }

    handleLeaveCashRegister() {
        this.props.leaveCashRegister();
    }

    handleCloseCashRegister() {
        swal({
            title: 'Kasse schließen',
            text: 'Soll die Kasse wirklich geschlossen werden? Dieser Vorgang kann nicht rückgängig gemacht werden. Bitte achte außerdem darauf, dass die Kasse mit einem Betrag von 0 € schließt.',
            icon: 'warning',
            buttons: true,
            dangerMode: true
        }).then((reallyDo) => {
            if (reallyDo) {
                this.props.closeCashRegister(this.props.cashRegister.cashRegister.id);
            }
        })
    }

    handleStartAddingAccounting() {
        this.setState({
            addingAccounting: true
        });
    }

    handleCancelAddAccounting(e) {
        e.preventDefault();
        this.setState({
            addingAccounting: false,
            addAccountingErrors: [],
            addAccountingAmount: '',
            addAccountingComment: '',
            addAccountingType: 'INGOING'
        });
    }

    handleCheckboxChange(e) {
        this.setState({
            [e.target.name]: !this.state[e.target.name]
        })
    }

    handleItemChange(key) {
        this.setState({
            items: this.state.items.map(i => {
                if (i.key === key) {
                    return {
                        ...i,
                        value: !i.value
                    }
                } else {
                    return i;
                }
            })
        })
    }

    componentWillReceiveProps(nextProps) {
        if((this.props.cashRegister.ticket && nextProps.cashRegister.ticket && this.props.cashRegister.ticket.ticket.ean !== nextProps.cashRegister.ticket.ticket.ean) || (!this.props.cashRegister.ticket && nextProps.cashRegister.ticket)) {
            this.setState({
                gotAllFoodStamps: (nextProps.cashRegister.ticket ? (nextProps.cashRegister.ticket.supporter.shoudGetAllFoodStamps ? nextProps.cashRegister.ticket.supporter.shoudGetAllFoodStamps : false) : false),
                gotCarSticker: nextProps.cashRegister.ticket ? nextProps.cashRegister.ticket.supporter.gotCarSticker : false,
                gotElectroBeer: nextProps.cashRegister.ticket ? nextProps.cashRegister.ticket.supporter.gotElectroBeer : false,
                gotPresent: nextProps.cashRegister.ticket ? nextProps.cashRegister.ticket.supporter.gotPresent : false,
                items: nextProps.cashRegister.ticket ? nextProps.cashRegister.ticket.supporter.items : null,
                printShiftInfos: nextProps.cashRegister.ticket ? nextProps.cashRegister.ticket.supporter.period.name.includes('during') : false,
                stewardNumber: '',
                checkOutLoading: false
            });
        }
    }

    handleAddAccounting(e) {
        e.preventDefault();
        this.setState({
            addingAccounting: false
        });
        axios(config.server.endpoint + 'backend/cashRegister/accounting', {
            method: 'post',
            data: {
                amount: this.state.addAccountingAmount,
                comment: this.state.addAccountingComment,
                type: this.state.addAccountingType,
                cashRegister: this.props.cashRegister.cashRegister.id
            }
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    this.props.getCashRegister(this.props.cashRegister.cashRegister.id);
                    this.setState({
                        addingAccounting: false,
                        addAccountingErrors: [],
                        addAccountingAmount: '',
                        addAccountingComment: '',
                        addAccountingType: 'INGOING'
                    });
                } else {
                    this.setState({
                        addingAccounting: true,
                        addAccountingErrors: response.data.errors
                    })
                }
            }
        });
    }

    handleRenderPdf(e, id) {
        e.preventDefault();
        axios(config.server.endpoint + 'backend/cashRegister/pdf/' + id, {
            method: 'get',
            responseType: 'blob'
        }).then((response) => {
            if (response.status === 200) {
                fileDownload(response.data, moment().format('YYYY-MM-DD-HH-mm') + '_cashRegister_' + id + '.pdf', 'application/pdf');
            }
        });
    }

    handleRenderOverviewPdf(e) {
        e.preventDefault();
        axios(config.server.endpoint + 'backend/cashRegister/pdf/overview', {
            method: 'get',
            responseType: 'blob'
        }).then((response) => {
            if (response.status === 200) {
                fileDownload(response.data, moment().format('YYYY-MM-DD-HH-mm') + '_cashRegister_overview.pdf', 'application/pdf');
            }
        });
    }

    handlePrintAllCashRegisters(e) {
        e.preventDefault();
        axios(config.server.endpoint + 'backend/cashRegister/pdf', {
            method: 'get',
            responseType: 'blob'
        }).then((response) => {
            if (response.status === 200) {
                fileDownload(response.data, moment().format('YYYY-MM-DD-HH-mm') + '_cashRegister_all.pdf', 'application/pdf');
            }
        });
    }

    handlePrintExcel(e) {
        e.preventDefault();
        axios(config.server.endpoint + 'backend/cashRegister/excel', {
            method: 'get',
            responseType: 'blob'
        }).then((response) => {
            if (response.status === 200) {
                fileDownload(response.data, moment().format('YYYY-MM-DD-HH-mm') + '_cashRegister_all.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            }
        });
    }

    handleManuallyTicket() {
        history.push("/cashRegister/" + this.state.ticketEanManually);
        this.props.getTicket(this.state.ticketEanManually);
        this.setState({
            ticketEanManually: ''
        });
    }

    handleQrCodeScan(val) {
        history.push("/cashRegister/" + val);
        this.props.getTicket(val);
        this.setState({
            ticketEanManually: ''
        });
    }

    render() {
        const {cashRegister, t} = this.props;
        return (
            <div className="CashRegisterScreen">
                <CodeReader onScan={(val) => this.handleQrCodeScan(val)}/>
                <PageHeader title={t('cashRegisterScreen.title')}/>
                {cashRegister.ticketLoading ? (
                  <div className="row">
                      <div className="col-xs-12 m-t text-center">
                          <i className="fa fa-spin fa-5x fa-spinner"/>
                      </div>
                  </div>
                ) : (
                  cashRegister.cashRegister ? (
                    cashRegister.ticket ? (
                      <div className="ibox m-t">
                          <div className="ibox-title">
                              <h5>
                                  {t('cashRegisterScreen.ticket.title')}
                              </h5>
                              <div className="ibox-tools">
                                  <a onClick={this.props.closeTicket}>
                                      <i className="fa fa-close"/>
                                  </a>
                              </div>
                          </div>
                          <div className="ibox-content">
                              <div className="row">
                                  <div className="col-md-8">
                                      <div className="row">
                                          <div className="col-lg-3">
                                              {t('cashRegisterScreen.ean')}
                                          </div>
                                          <div className="col-lg-9">
                                              <b>
                                                  {cashRegister.ticket.ticket.ean}
                                              </b>
                                          </div>
                                      </div>
                                      <div className="row">
                                          <div className="col-lg-3">
                                              {t('cashRegisterScreen.isValid')}
                                          </div>
                                          <div className="col-lg-9">
                                              <b>
                                                  {cashRegister.ticket.ticket.isValid ? t('default.true') : t('default.false')}
                                              </b>
                                          </div>
                                      </div>
                                      {cashRegister.ticket.ticket.invalidatedAt ? (
                                        <div className="row">
                                            <div className="col-lg-3">
                                                {t('cashRegisterScreen.invalidatedAt')}
                                            </div>
                                            <div className="col-lg-9">
                                                <b>
                                                    {moment(cashRegister.ticket.ticket.invalidatedAt).format('DD.MM.YYYY HH:mm')}
                                                </b>
                                            </div>
                                        </div>
                                      ) : null}
                                      {cashRegister.ticket.ticket.checkedInAt ? (
                                        <div className="row">
                                            <div className="col-lg-3">
                                                {t('cashRegisterScreen.checkedInAt')}
                                            </div>
                                            <div className="col-lg-9">
                                                <b>
                                                    {moment(cashRegister.ticket.ticket.checkedInAt).format('DD.MM.YYYY HH:mm')}
                                                </b>
                                            </div>
                                        </div>
                                      ) : (
                                        null
                                      )}
                                      <div className="hr-line-dashed"/>
                                      {cashRegister.ticket.supporter ? (
                                        <div>
                                            <div className="row">
                                                <div className="col-lg-3">
                                                    {t('cashRegisterScreen.project')}
                                                </div>
                                                <div className="col-lg-9">
                                                    <b>
                                                        {cashRegister.ticket.supporter.projectName}
                                                    </b>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-3">
                                                    {t('cashRegisterScreen.period')}
                                                </div>
                                                <div className="col-lg-9">
                                                    <b>
                                                        {cashRegister.ticket.supporter.period.name}: {moment(cashRegister.ticket.supporter.period.startAt).format('DD.MM.YYYY')} - {moment(cashRegister.ticket.supporter.period.endAt).format('DD.MM.YYYY')}
                                                    </b>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-3">
                                                    {t('cashRegisterScreen.state')}
                                                </div>
                                                <div className="col-lg-9">
                                                    <b>
                                                        {t('cashRegisterScreen.supporterState.' + cashRegister.ticket.supporter.state)}
                                                    </b>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-3">
                                                    {t('cashRegisterScreen.name')}
                                                </div>
                                                <div className="col-lg-9">
                                                    <b>
                                                        {cashRegister.ticket.supporter.firstname} {cashRegister.ticket.supporter.lastname} ({cashRegister.ticket.supporter.email})
                                                    </b>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-3">
                                                    {t('cashRegisterScreen.shifts')}
                                                </div>
                                                <div className="col-lg-9">
                                                    {cashRegister.ticket.supporter.shifts.map((shift, i) => (
                                                      <div key={i}>
                                                          {moment(shift.startAt).format('DD.MM.YYYY HH:mm')} - {moment(shift.endAt).format('HH:mm')} ({shift.location})
                                                          - {shift.state}
                                                      </div>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-3">
                                                    {t('cashRegisterScreen.ticketToasterProvisions')}
                                                </div>
                                                <div className="col-lg-9">
                                                    <table className="table">
                                                        <tbody>
                                                        {cashRegister.ticket.supporter.ticketToasterProvisions ? cashRegister.ticket.supporter.ticketToasterProvisions.map((ttp, ttpI) => (
                                                          <tr key={ttpI}>
                                                              <td>
                                                                  {ttp.kitchen}
                                                              </td>
                                                              <td>
                                                                  {ttp.backstageArea}
                                                              </td>
                                                              <td>
                                                                  {moment(ttp.opensAt).format('DD.MM.YY')} - {moment(ttp.closesAt).format('DD.MM.YY')}
                                                              </td>
                                                              <td>
                                                                  {ttp.amount} {t('cashRegister.ticketToasterProvisions.meals')}
                                                              </td>
                                                          </tr>
                                                        )) : null}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            {/*cashRegister.ticket.supporter.askForSteward ? (
                                              <div className="row">
                                                  <div className="col-xs-12">
                                                      <div className="alert alert-success p-lg">
                                                          <h2><strong>Diese:r Supporter:in wäre als Ordner:in
                                                              geeignet.</strong></h2>
                                                      </div>
                                                  </div>
                                              </div>
                                            ) : null*/}
                                            {cashRegister.ticket.supporter.stewardFormReceived ? (
                                              <div className="row" style={{marginTop: 30}}>
                                                  <div className="col-xs-12">
                                                      <div className="alert alert-warning p-lg" style={{background: '#ffbb73'}}>
                                                          <h2>
                                                              <strong>Vor dir steht ein:e Supporter:in, die/der auch Ordner:in ist.</strong><br/>
                                                              Händige der Person eine gelbe Weste aus und tippe die Nummer der Weste in das Feld unten. Sage dazu Folgendes:<br/>
                                                              - bitte die Weste nicht verlieren<br/>
                                                              - bringe die Weste zu jeder Ordner:innen-Schicht mit<br/>
                                                              - Bau keinen Mist damit - die Nummer identifiziert dich<br/>
                                                              - bring die Weste zur Auszahlung mit - ohne Weste kein Geld zurück
                                                          </h2>
                                                      </div>
                                                  </div>
                                              </div>
                                            ) : null}
                                        </div>
                                      ) : (
                                        cashRegister.ticketNotFound ? (
                                          <div className="text-bold text-danger">
                                              {t('cashRegisterScreen.supporterNotFound')}
                                          </div>
                                        ) : (
                                          <div className="text-bold text-primary">
                                              {t('cashRegisterScreen.scanTicket')}
                                          </div>
                                        )

                                      )}
                                  </div>
                                  <div className="col-md-4">
                                      {cashRegister.ticket.supporter.uuid ? (
                                        <QRCode value={cashRegister.ticket.supporter.uuid} size={256}
                                                className="pull-right"/>
                                      ) : null}
                                  </div>
                              </div>
                          </div>
                      </div>
                    ) : (
                      <div className="alert alert-info m-t">
                          {t('cashRegisterScreen.ticket.notFound')}
                          <div className="row m-t">
                              <div className="col-lg-3">
                                  {t('cashRegisterScreen.ticket.byHand')}:
                              </div>
                              <div className="col-lg-4">
                                  <input type="text" name="ticketEanManually" value={this.state.ticketEanManually}
                                         onChange={this.handleInputChange} onKeyUp={(e) => {
                                      if (e.keyCode === 13) this.handleManuallyTicket()
                                  }} className="form-control"/>
                              </div>
                              <div className="col-lg-5">
                                  <button className="btn btn-primary" onClick={this.handleManuallyTicket}>
                                      {t('default.send')}
                                  </button>
                              </div>
                          </div>
                      </div>
                    )
                  ) : null
                )}
                {cashRegister.ticket && cashRegister.cashRegister && cashRegister.ticket.ticket.isValid && cashRegister.cashRegister.open ? (
                    <div className="ibox m-t">
                        <div className="ibox-title">
                            <h5>
                                {t('cashRegisterScreen.checkIn.title')}
                            </h5>
                        </div>
                        <div className="ibox-content">
                            <div className="row">
                                <div className="col-xs-12">
                                    {/*cashRegister.ticket.supporter.canChooseCarSticker ? (
                                        <div className="checkbox checkbox-default">
                                            <input type="checkbox" name="gotCarSticker" id="ticket-gotCarSticker-checkbox" checked={this.state.gotCarSticker}
                                                   onChange={this.handleCheckboxChange}/>
                                            <label htmlFor="ticket-gotCarSticker-checkbox">{t('cashRegisterScreen.checkIn.gotCarSticker.label')}</label>
                                        </div>
                                    ) : null*/}
                                    {cashRegister.ticket.supporter.stewardFormReceived ? (
                                      <div className="form-group">
                                          <label>Westennummer</label>
                                          <input name="stewardNumber" value={this.state.stewardNumber} onChange={this.handleInputChange} className="form-control" style={{width: 200}}/>
                                      </div>
                                    ) : null}
                                    {cashRegister.ticket.supporter.canChooseElectroBeer ? (
                                        <div className="checkbox checkbox-default">
                                            <input type="checkbox" name="gotElectroBeer" id="ticket-gotElectroBeer-checkbox" checked={this.state.gotElectroBeer}
                                                   onChange={this.handleCheckboxChange}/>
                                            <label htmlFor="ticket-gotElectroBeer-checkbox">{t('cashRegisterScreen.checkIn.gotElectroBeer.label')}</label>
                                        </div>
                                    ) : null}
                                    {cashRegister.ticket.supporter.shoudGetAllFoodStamps ? (
                                        <div className="checkbox checkbox-default">
                                            <input type="checkbox" name="gotAllFoodStamps" id="ticket-gotAllFoodStamps-checkbox" checked={this.state.gotAllFoodStamps}
                                                   onChange={this.handleCheckboxChange}/>
                                            <label htmlFor="ticket-gotAllFoodStamps-checkbox">{t('cashRegisterScreen.checkIn.gotAllFoodStamps.label')}</label>
                                        </div>
                                    ) : null}
                                    {this.state.items ? this.state.items.map((item, iI) => (
                                      <div className="checkbox checkbox-primary" key={iI}>
                                          {item.type === 'BOOLEAN' ? (
                                            <Fragment>
                                                <input type="checkbox"
                                                       checked={item.value ? item.value : false} name={item.key}
                                                       id={`supporterProject-${item.key}-checkbox`}
                                                       onChange={() => this.handleItemChange(item.key)}/>
                                                <label htmlFor={`supporterProject-${item.key}-checkbox`}>
                                                    {t(`supporterProject.${item.key}.checkbox.label`)}
                                                </label>
                                            </Fragment>
                                          ) : null }
                                      </div>
                                    )) : null}
                                    <div className="checkbox checkbox-default">
                                        <input type="checkbox" name="printShiftInfos" id="ticket-printShiftInfos-checkbox" disabled={!this.props.printer.selectedPrinter} checked={this.props.printer.selectedPrinter && this.state.printShiftInfos}
                                               onChange={this.handleCheckboxChange}/>
                                        <label htmlFor="ticket-printShiftInfos-checkbox">
                                            {t('cashRegisterScreen.checkIn.printShiftInfos.label')}
                                            {!this.props.printer.selectedPrinter ? (
                                                <span className="text-danger">&nbsp;&nbsp;Achtung: Kein Drucker ausgewählt!</span>
                                            ) : null}
                                        </label>
                                    </div>
                                    <button className="btn btn-primary" onClick={this.handleCheckInTicket} disabled={cashRegister.ticket.supporter.stewardFormReceived && (!this.state.stewardNumber || this.state.stewardNumber.length === 0)}>
                                        {t('cashRegisterScreen.checkIn.submit', {ticketPrice: this.props.project.selectedProject.ticketPrice})}
                                    </button>
                                    {cashRegister.ticket.supporter.stewardFormReceived && (!this.state.stewardNumber || this.state.stewardNumber.length === 0) ? (
                                      <div className="text-danger">
                                          Bitte gib die Westennummer ein, um den/die Supporter:in einchecken zu können
                                      </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
                {cashRegister.ticket && cashRegister.cashRegister && cashRegister.ticket.supporter.checkOut && cashRegister.ticket.supporter.checkOut.readyForCheckout && cashRegister.cashRegister.open ? (
                    <div className="ibox m-t">
                        <div className="ibox-title">
                            <h5>
                                {t('cashRegisterScreen.checkOut.title')}
                            </h5>
                        </div>
                        <div className="ibox-content">
                            <div className="row">
                                <div className="col-xs-12">
                                    {t('cashRegisterScreen.checkOut.shiftAmount')}: {cashRegister.ticket.supporter.checkOut.doneShiftAmount}/{cashRegister.ticket.supporter.checkOut.neededShiftAmount}
                                </div>
                            </div>
                            <div className="row m-t">
                                <div className="col-xs-12">
                                    <div className="checkbox checkbox-default">
                                        <input type="checkbox" name="gotPresent" id="ticket-gotPresent-checkbox" checked={this.state.gotPresent}
                                               onChange={this.handleCheckboxChange}/>
                                        <label htmlFor="ticket-gotPresent-checkbox">{t('cashRegisterScreen.checkOut.gotPresent.label')}</label>
                                    </div>
                                    <button className={"btn btn-" + (cashRegister.ticket.supporter.checkOut.doneShiftAmount >= cashRegister.ticket.supporter.checkOut.neededShiftAmount ? 'primary' : 'danger')} onClick={this.handleCheckOutSupporter} disabled={this.state.checkOutLoading}>
                                        {t('cashRegisterScreen.checkOut.submit', {ticketPrice: this.props.project.selectedProject.ticketPrice})}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
                {cashRegister.cashRegisterLoading ? (
                    <div className="row">
                        <div className="col-xs-12 m-t text-center">
                            <i className="fa fa-spin fa-5x fa-spinner"/>
                        </div>
                    </div>
                ) : (
                    cashRegister.cashRegister ? (
                        <div className="ibox m-t">
                            <div className="ibox-title">
                                <h5>
                                    {t('cashRegisterScreen.cashRegister.title')}
                                </h5>
                            </div>
                            <div className="ibox-content">
                                {this.state.addingAccounting ? (
                                    <form onSubmit={this.handleAddAccounting}>
                                        <div className="row">
                                            <div className="col-xs-4">
                                                <div
                                                    className={"form-group" + ((this.state.addAccountingErrors && this.state.addAccountingErrors.amount) ? ' has-error' : '')}>
                                                    <label>{t('cashRegister.addAccounting.amount.label')}</label>
                                                    <input type="text" value={this.state.addAccountingAmount} className="form-control" name="addAccountingAmount" onChange={this.handleInputChange}/>

                                                    {(this.state.addAccountingErrors && this.state.addAccountingErrors.amount) ? (
                                                        <span className="help-block">
                                                                {t('cashRegister.addAccounting.amount.error.' + this.state.addAccountingErrors.amount)}
                                                            </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-xs-4">
                                                <div
                                                    className={"form-group" + ((this.state.addAccountingErrors && this.state.addAccountingErrors.type) ? ' has-error' : '')}>
                                                    <label>{t('cashRegister.addAccounting.type.label')}</label>
                                                    <select value={this.state.addAccountingType} className="form-control" name="addAccountingType" onChange={this.handleInputChange}>
                                                        {this.state.availableAccountingTypes.map((type, i) => (
                                                            <option key={i} value={type}>{type}</option>
                                                        ))}
                                                    </select>

                                                    {(this.state.addAccountingErrors && this.state.addAccountingErrors.type) ? (
                                                        <span className="help-block">
                                                                {t('cashRegister.addAccounting.type.error.' + this.state.addAccountingErrors.type)}
                                                            </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-xs-4">
                                                <div
                                                    className={"form-group" + ((this.state.addAccountingErrors && this.state.addAccountingErrors.comment) ? ' has-error' : '')}>
                                                    <label>{t('cashRegister.addAccounting.comment.label')}</label>
                                                    <textarea value={this.state.addAccountingComment} className="form-control" name="addAccountingComment" onChange={this.handleInputChange}/>

                                                    {(this.state.addAccountingErrors && this.state.addAccountingErrors.comment) ? (
                                                        <span className="help-block">
                                                                {t('cashRegister.addAccounting.comment.error.' + this.state.addAccountingErrors.comment)}
                                                            </span>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-12 text-right">
                                                <button type="default" className="btn btn-default m-r" onClick={this.handleCancelAddAccounting}>
                                                    {t('default.cancel')}
                                                </button>
                                                <button type="submit" className="btn btn-primary">
                                                    {t('default.save')}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                ) : null }
                                <div className="row">
                                    <div className="col-lg-3">
                                        {t('cashRegisterScreen.cr.name')}
                                    </div>
                                    <div className="col-lg-3">
                                        <b>
                                            {cashRegister.cashRegister.name}
                                        </b>
                                    </div>
                                    <div className="col-lg-3">
                                        {t('cashRegisterScreen.cr.status')}
                                    </div>
                                    <div className="col-lg-3">
                                        <b>
                                            {cashRegister.cashRegister.open ? t('cashRegisterScreen.cr.status.open') : t('cashRegisterScreen.cr.status.closed')}
                                        </b>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-3">
                                        {t('cashRegisterScreen.cr.openedBy')}
                                    </div>
                                    <div className="col-lg-3">
                                        <b>
                                            {cashRegister.cashRegister.openedBy} ({moment(cashRegister.cashRegister.openedAt).format('DD.MM.YYYY HH:mm')})
                                        </b>
                                    </div>
                                    {cashRegister.cashRegister.closedBy ? (
                                        <div className="col-lg-3">
                                            {t('cashRegisterScreen.cr.closedBy')}
                                        </div>
                                    ) : null}
                                    {cashRegister.cashRegister.closedBy ? (
                                        <div className="col-lg-3">
                                            <b>
                                                {cashRegister.cashRegister.closedBy} ({moment(cashRegister.cashRegister.closedAt).format('DD.MM.YYYY HH:mm')})
                                            </b>
                                        </div>
                                    ) : null}
                                </div>
                                <div className="row m-t">
                                    <div className="col-lg-3">
                                        {t('cashRegisterScreen.cr.total')}
                                    </div>
                                    <div className="col-lg-3">
                                        <b>
                                            {cashRegister.cashRegister.total} €
                                        </b>
                                    </div>
                                    <div className="col-lg-6 text-right">
                                        <div className="btn-group">
                                            {this.props.roles.find((role) => (role === 'ROLE_CASH_ADMIN')) ? (
                                              <button onClick={this.handleStartAddingAccounting}
                                                      className="btn btn-primary">
                                                  {t('cashRegisterScreen.cr.addAccounting')}
                                              </button>
                                            ) : null}
                                            <button onClick={this.handleLeaveCashRegister} className="btn btn-warning">
                                                {t('cashRegisterScreen.cr.leave')}
                                            </button>
                                            {!cashRegister.cashRegister.closedBy && this.props.roles.find((role) => (role === 'ROLE_CASH_ADMIN')) ? (
                                                <button onClick={this.handleCloseCashRegister} className="btn btn-danger">
                                                    {t('cashRegisterScreen.cr.close')}
                                                </button>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                                <div className="row m-t">
                                    <div className="col-xs-12">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        {t('cashRegister.cashRegister.accounting.createdAt')}
                                                    </th>
                                                    <th>
                                                        {t('cashRegister.cashRegister.accounting.createdBy')}
                                                    </th>
                                                    <th>
                                                        {t('cashRegister.cashRegister.accounting.amount')}
                                                    </th>
                                                    <th>
                                                        {t('cashRegister.cashRegister.accounting.type')}
                                                    </th>
                                                    <th>
                                                        {t('cashRegister.cashRegister.accounting.supporter')}
                                                    </th>
                                                    <th>
                                                        {t('cashRegister.cashRegister.accounting.comment')}
                                                    </th>
                                                    <th>
                                                        Beleg
                                                    </th>
                                                    <th/>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {cashRegister.cashRegister.accountings.map((accounting, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            {moment(accounting.createdAt).format('DD.MM.YYYY HH:mm')}
                                                        </td>
                                                        <td>
                                                            {accounting.createdBy}
                                                        </td>
                                                        <td>
                                                            {accounting.amount}
                                                        </td>
                                                        <td>
                                                            {accounting.type}
                                                        </td>
                                                        <td>{accounting.supporter ? (
                                                            accounting.supporter.firstname + ' ' + accounting.supporter.lastname
                                                        ) : ''}
                                                        </td>
                                                        <td>
                                                            {accounting.comment}
                                                        </td>
                                                        <td>
                                                            {accounting.receipt ? (
                                                              <a href={accounting.receipt} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-xs">
                                                                  <i className="fa fa-file-pdf-o"/>
                                                              </a>
                                                            ) : null}
                                                        </td>
                                                        <td>
                                                            {accounting.supporter ? (
                                                                <button className="btn btn-primary btn-xs" onClick={() => this.props.printShiftInfos(accounting.supporter.id)}>
                                                                    <i className="fa fa-print"/>
                                                                </button>
                                                            ) : null}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="ibox m-t">
                            <div className="ibox-title">
                                <h5>
                                    {t('cashRegisterScreen.cashRegister.title')}
                                </h5>
                            </div>
                            <div className="ibox-content">
                                {t('casRegisterScreen.cashRegisterNotFound')}
                                {this.props.roles.find((role) => (role === 'ROLE_CASH_ADMIN')) ? (
                                  <Fragment>
                                      <div className="hr-line-dashed"/>
                                      <div className="row">
                                          <div className="col-lg-3">
                                              {t('cashRegisterScreen.cashRegister.newCashRegister.title')}
                                          </div>
                                          <div className="col-lg-3">
                                              <input type="text" value={this.state.newCashRegisterName}
                                                     name="newCashRegisterName" onChange={this.handleInputChange}
                                                     className="form-control"/>
                                          </div>
                                          <div className="col-lg-3">
                                              <select name="fiskalyClient" value={this.state.fiskalyClient}
                                                      onChange={this.handleInputChange} className="form-control">
                                                  <option value=""/>
                                                  {this.state.fiskalyClients.map((fc, fcI) => (
                                                    <option key={fcI} value={fc.id}>
                                                        {fc.name}
                                                    </option>
                                                  ))}
                                              </select>
                                          </div>
                                          <div className="col-lg-3">
                                              <button className="btn btn-primary" onClick={this.handleNewCashRegister}
                                                      disabled={!(this.state.newCashRegisterName.length > 0 && this.state.fiskalyClient.length > 0)}>
                                                  {t('cashRegisterScreen.cashRegister.newCashRegister.submit')}
                                              </button>
                                          </div>
                                      </div>
                                  </Fragment>
                                ) : null}
                                <div className="hr-line-dashed"/>
                                { cashRegister.openCashRegisters && cashRegister.openCashRegisters.length > 0 ? (
                                    <div className="row">
                                        <div className="col-lg-3">
                                            {t('cashRegisterScreen.cashRegister.existingCashRegister')}
                                        </div>
                                        <div className="col-lg-4">
                                            <select name="existingCashRegister" value={this.state.existingCashRegister ? this.state.existingCashRegister : cashRegister.openCashRegisters[0].id} onChange={this.handleInputChange} className="form-control">
                                                {cashRegister.openCashRegisters.map((cr, i) => (
                                                    <option key={i} value={cr.id}>
                                                        {cr.name} ({cr.openedBy}, {moment(cr.openedAt).format('DD.MM.YYYY HH:mm')})
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-lg-3">
                                            <button className="btn btn-primary" onClick={this.handleJoinCashRegister}>
                                                {t('cashRegisterScreen.cashRegister.joinCashRegister.submit')}
                                            </button>
                                        </div>
                                    </div>
                                ) : null }
                            </div>
                        </div>
                    )
                )}
                {this.props.roles.find((role) => (role === 'ROLE_CASH_ADMIN')) ? (cashRegister.closedCashRegistersLoading ? (
                  <div className="row">
                      <div className="col-xs-12 m-t text-center">
                          <i className="fa fa-spin fa-5x fa-spinner"/>
                      </div>
                  </div>
                ) : (
                  <div className="ibox m-t">
                      <div className="ibox-title">
                          <h5>
                              {t('cashRegisterScreen.closedCashRegisters.title')}
                          </h5>
                          <div className="ibox-tools">
                              <a onClick={this.handleRenderOverviewPdf}>
                                  Übersicht
                              </a>
                              <a onClick={this.handlePrintAllCashRegisters}>
                                  Alle Berichte
                              </a>
                              <a onClick={this.handlePrintExcel}>
                                  Export als .xlsx
                              </a>
                          </div>
                      </div>
                      <div className="ibox-content">
                          <div className="row m-t">
                              <div className="col-xs-12">
                                  <table className="table">
                                      <thead>
                                      <tr>
                                          <th>
                                              {t('cashRegister.cashRegister.closedCashRegisters.name')}
                                          </th>
                                          <th>
                                              {t('cashRegister.cashRegister.closedCashRegisters.total')}
                                          </th>
                                          <th>
                                              {t('cashRegister.cashRegister.closedCashRegisters.opened')}
                                          </th>
                                          <th>
                                              {t('cashRegister.cashRegister.closedCashRegisters.closed')}
                                          </th>
                                          <th/>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      {cashRegister.closedCashRegisters ? cashRegister.closedCashRegisters.map((cashRegister, i) => (
                                        <tr key={i}>
                                            <td>
                                                {cashRegister.name}
                                            </td>
                                            <td>
                                                {cashRegister.total}
                                            </td>
                                            <td>
                                                {moment(cashRegister.openedAt).format('DD.MM.YYYY HH:mm')} / {cashRegister.openedBy}
                                            </td>
                                            <td>
                                                {moment(cashRegister.closedAt).format('DD.MM.YYYY HH:mm')} / {cashRegister.closedBy}
                                            </td>
                                            <td className="text-right">
                                                <button value={cashRegister.id}
                                                        onClick={(e) => this.handleRenderPdf(e, cashRegister.id)}
                                                        className="btn btn-primary btn-xs">
                                                    <i className="fa fa-file-pdf-o"/>
                                                </button>
                                            </td>
                                        </tr>
                                      )) : null}
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                      </div>
                  </div>
                )) : null}
            </div>
        )
    }
}

export default translate()(CashRegisterScreen);
